import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Grid, Icon, Typography } from '@mui/material';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { useNavigate } from 'react-router-dom';
import IntlMessages from '@projectK/helpers/IntlMessages';
import routesConfig from '../../../../../../../apps/admin/src/core/AppRoutes/routesConfig';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import SubMenu from './SubMenu';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import { isStudent } from '@projectK/context/RolesProvider';

const TopMenu = (path) => {
  const navigate = useNavigate();
  const { isMobile } = useMobileSettings();
  const companyTheme = CompanyTheme();
  const { user } = useAuthUser();
  let configrole = '';

  if (user) {
    configrole = user.role;
  }
  const routeconfig = routesConfig(configrole);

  // State to track the active submenu item
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  useEffect(() => {
    if (path?.path) {
      setActiveSubMenu(path?.path);
    }
  }, [path]);

  const handleSubMenuClick = (url) => {
    navigate(url);
    setActiveSubMenu(url);
  };
  return (
    <Grid
      container
      spacing={2}
      className='right-tabs'
      style={
        isMobile && isStudent(user) ? { marginTop: '50px' } : {}
      }
    >
      {routeconfig.map((item) => {
        if (
          item?.url === path?.path ||
          item?.url1 === path?.path ||
          item?.url2 === path?.path
        ) {
          return item?.children?.map((data, index) => (
            <Grid key={index+0} item className='right-tab-item'>
              <Card
                variant='outlined'
                onClick={() => handleSubMenuClick(data.url)}
                sx={{
                  '&.tab-item.active': {
                    backgroundColor: companyTheme
                      ? companyTheme.primary.main
                      : '#2196f3',
                    color: companyTheme
                      ? companyTheme.secondary.main
                      : '#000000',
                  },
                }}
                className={`tab-item ${
                  activeSubMenu === data.url ? 'active' : ''
                }`}
              >
                <CardContent>
                  {data.icon && (
                    <Box component='span' mr={3.25}>
                      <Icon color='action' className={'nav-item-icon'}>
                        {data.icon}
                      </Icon>
                    </Box>
                  )}
                  <Typography gutterBottom variant='h2' component='div'>
                    <IntlMessages id={data.messageId} />
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ));
        }
        return item?.children?.map((list) => {
          if (
            list?.url === path?.path ||
            list?.url1 === path?.path ||
            list?.url2 === path?.path
          ) {
            return item?.children?.map((data, index) => (
              <>
                <Grid key={index+0} item className='right-tab-item submenu-tabs'>
                  <Card
                    variant='outlined'
                    onClick={() => handleSubMenuClick(data.url)} //NOSONAR
                    sx={{
                      '&.tab-item.active': {
                        backgroundColor: companyTheme
                          ? companyTheme.primary.main
                          : '#2196f3',
                        color: companyTheme
                          ? companyTheme?.secondary?.main
                          : '#000000',
                      },
                    }}
                    className={`tab-item ${
                      activeSubMenu === data.url ? 'active' : ''
                    }`}
                  >
                    <CardContent>
                      {data.icon && (
                        <Box component='span' mr={3.25}>
                          <Icon color='action' className={'nav-item-icon'}>
                            {data.icon}
                          </Icon>
                        </Box>
                      )}
                      <Typography gutterBottom variant='h2' component='div'>
                        <IntlMessages id={data.messageId} />
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
               
                  <Grid   key={index+0}  className='right-tab-item sub-menu-items'>

                  {data.children &&
                    (data?.url === path?.path ||
                      data?.url1 === path?.path ||
                      data?.url2 === path?.path) && (
                      <SubMenu
                        data={data}
                        activeSubMenu={activeSubMenu}
                        handleSubMenuClick={handleSubMenuClick}
                        companyTheme={companyTheme}
                      />
                    )}
                </Grid>
              </>
            ));
          }
        });
      })}
    </Grid>
  );
};

export default TopMenu;
